import React from 'react';

const ArrowIcon = ({ variant, ...rest }) => (
  <svg
    viewBox="0 0 10.174 5.5001621"
    height="5.5001621"
    width="10.174"
    {...rest}
  >
    <path
      d="m 12.075,15.174 c -0.254,0 -0.507,-0.243 -0.555,-0.292 C 11.346,14.753 7.716,11.123 7.21,10.616 A 0.652,0.652 0 0 1 7,10.122 C 7.012,9.826 7.24,9.624 7.265,9.602 L 11.563,5.317 C 11.619,5.256 11.879,5 12.126,5 12.238,5 12.5,5.052 12.5,5.53 v 9 c 0,0.56 -0.266,0.644 -0.425,0.644 z"
      transform={`translate(-4.663,-7.337) rotate(${
        variant === 'up'
          ? 90
          : variant === 'down'
          ? -90
          : variant === 'right'
          ? 180
          : 0
      },9.75,10.087)`}
    />
  </svg>
);

export default ArrowIcon;
